module.exports = __webpack_public_path__ + "media/images/flags/4x3/brb-b0e171749c98f62df901ee8bd78c8f39.svg";